import api from './api';

export default {
  getPlatformData(startDate, endDate) {
    const params = { startDate, endDate };
    return new Promise((resolve, reject) => {
      api
        .get('dashboard/platform', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getPartnerData(startDate, endDate, partnerId) {
    const params = { startDate, endDate, partnerId };
    return new Promise((resolve, reject) => {
      api
        .get('dashboard/partner', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  async getFunderData(startDate, endDate, funderId) {
    const params = { startDate, endDate, funderId };
    const { data } = await api.get('dashboard/funder', { params });
    return data;
  }
};
